import { render } from "./WarningAudio.vue?vue&type=template&id=da2c4ba0"
import script from "./WarningAudio.vue?vue&type=script&lang=js"
export * from "./WarningAudio.vue?vue&type=script&lang=js"

import "./WarningAudio.vue?vue&type=style&index=0&id=da2c4ba0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__